var _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.218018,
    width: 27.0229,
    height: 27.0229,
    fill: "url(#pattern0_173_647)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_173_647",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_173_647",
    transform: "scale(0.0111111)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_173_647",
    width: 90,
    height: 90,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFoAAABaCAYAAAA4qEECAAAACXBIWXMAAAsTAAALEwEAmpwYAAACSElEQVR4nO2cwU4CMRCGfzjsivG9QWOCEQ1wEN/BA+GBXLwYNRDlOGaTMTFkMYR2Z8f2/5I90ADZ+SjtMLQFCCGEEEIIIYQQQsgP5wDuAXwAkESvdwB3AAZdfuwzByLE6Kpj7YQ+gC8HAsTo+tSYKRqJis5t6JiiQ+oJYqIThiR6vQG47XoytKQEcAngBcAawEjbSEQKAE8NvW0F4Iym25UslG0nWSjbTrJQtp1kSV12oZlAnQVUmgnUbSGUAJYB6dgyQjbSRlxBjBoCrdtCmETIfW8cxhVE1XBDddup9PWnbqjoLYCeo7hcit5FEL0LrEu4E930FRsGvufjgXH3rzF5v23hMK4gCr2pKuKkcaGydzoEjHVyOyS61DF5q69Z6Ht4i8stvb3Hh0T/fn7IuEyOFE0iQdFGCHs0RSeF5NyjLWsCYig6i1qHB9Huah3rhhuq/9P776LXhnGdXBN4TkB0ZRiXu5qAdDx0JFfr8DIZZlPr2Cfr9M4SoWiKTgphj6bopJCcezRrHUaw1mEEax1GsNZhBGsdRrDWkSCSc3pniVA0RSeFsEdTdFJIzosc26h1DADMdeX/K4CrI5btXus26XrZ7oOeI+ItLne1jrnThehJ7WHp6YJy6fjIB3dbK9q4oU0E0RuHcbmrdYwjiB47jMtdraN0sqEzi3UdBbco+5W9SnUfuAUFj5HwI3vFnty+7BUlx6fUFKvSn8bDnA6v4tmkRuR0wOAMHcGzSY2gaENyGjqm6BCeTUoIIYQQQgghhBCC/PgGcEZzo1b6t8MAAAAASUVORK5CYII="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeight);
export default __webpack_public_path__ + "static/media/Height.6bee1cfbfe16271682e326ae9f0fac3b.svg";
export { ForwardRef as ReactComponent };